import { render } from "./RecaptchaCheck.vue?vue&type=template&id=2c226de0&ts=true"
import script from "./RecaptchaCheck.vue?vue&type=script&lang=ts"
export * from "./RecaptchaCheck.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__